import React, { useState } from 'react'
import { View, ScrollView } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import tw from 'tailwind-rn'

import { RootStackParamList } from '../../navigators/AppNavigator'
import ActionCreators from '../../store/actions'
import styles from './styles'
import { HGView, HGLink, HGText, HGButton } from '../../components/HGUI'
import ModalForgotPassword from '../../components/HGModal/ModalForgotPassword'
import LoginForm, { Credentials } from './LoginForm'
import HansGretelLogo from './HansGretelLogo'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const SignInScreen = (props: Props) => {
  const [modalForgotPasswordVisible, setModalForgotPasswordVisible] = useState(
    false
  )
  const { navigation } = props
  const dispatch = useDispatch()
  const { sessionExpired, loggedIn } = useSelector((state) => state.user)

  const handleFormSubmit = async (
    { username, password }: Credentials,
    setSubmitting: (value: boolean) => void
  ) => {
    // Validate and login user
    try {
      setSubmitting(true)
      await dispatch(ActionCreators.loginUser({ username, password }))
    } catch (reason) {
      const { message: code } = reason as Error
      dispatch(ActionCreators.handleError({ code }))
    } finally {
      setSubmitting(false)
    }
  }

  const handleForgotPassword = () => {
    setModalForgotPasswordVisible(true)
  }

  const handleResetOnboarding = () => {
    dispatch(ActionCreators.resetOnboarding())
  }

  return (
    <>
      <ModalForgotPassword
        visible={modalForgotPasswordVisible}
        onSuccess={() => setModalForgotPasswordVisible(false)}
        onAbort={() => setModalForgotPasswordVisible(false)}
      />

      <ScrollView>
        <HGView style={styles.centerWrap}>
          <View style={styles.logo}>
            <HansGretelLogo />
          </View>

          <View style={styles.centerWrapInner}>
            {/* <HGText>SignInScreen</HGText> */}

            {!loggedIn && sessionExpired && (
              <View
                style={tw('mb-3 bg-yellow-50 p-2 flex flex-row rounded-md')}
              >
                <HGText style={tw('text-sm')}>
                  Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.
                </HGText>
              </View>
            )}
            <LoginForm onSubmit={handleFormSubmit} />

            <View style={tw('items-center')}>
              <View style={styles.secondaryActionBox}>
                <View style={styles.actionRow}>
                  <HGText style={styles.actionText}>
                    Noch kein Konto?
                    <HGLink onPress={() => navigation.navigate('SignUp')}>
                      {' '}
                      Registrieren
                    </HGLink>
                  </HGText>
                </View>

                <View style={styles.actionRow}>
                  <HGText style={styles.actionText}>
                    Passwort vergessen?
                    <HGLink onPress={() => handleForgotPassword()}>
                      {' '}
                      Zurücksetzen
                    </HGLink>
                  </HGText>
                </View>
              </View>
            </View>

            {process.env.MODE !== 'PRODUCTION' && (
              <View>
                <HGButton
                  title="Reset Onboarding"
                  type="inverted"
                  onPress={() => {
                    handleResetOnboarding()
                  }}
                />
              </View>
            )}
          </View>
        </HGView>
      </ScrollView>
    </>
  )
}

export default SignInScreen
